import * as React from 'react';
import Cookies from 'js-cookie';
import { AnchorListItem, Props as AnchorProps } from '../../components/Nav/AnchorListItem';
import { OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import DomainIcon from '@material-ui/icons/Domain';
import { Connection, ConnectionFilled } from '../../images';
import { _DeepReadonlyArray } from 'utility-types/dist/mapped-types';

const { Client, Subscriber } = OrganizationFeature;

export type Props = {
  userOrganization: {
    name: string;
    id: string;
    features: _DeepReadonlyArray<OrganizationFeature>;
  };
  rank?: number;
};

const handleChangeOrganizationToClient = (id: string) => () => {
  Cookies.set('AionCurrentOrganizationId', id, {
    sameSite: 'lax'
  });
  window.location.assign('/SSQV4/SSQV5/Home/OperatorHome');
};

const getIconByLevel = (level: number): JSX.Element => {
  switch (level) {
    case 1:
      return <DomainIcon />;
    case 2:
      return <Connection />;
    default:
      return <ConnectionFilled />;
  }
};

export const UserOrganizationItem: React.FC<Props> = ({ userOrganization: { features, name, id }, rank = 1 }) => {
  const isCHASOnlyCompliance =
    (features.includes(OrganizationFeature.ComplianceUK) || features.includes(OrganizationFeature.ComplianceAUS)) &&
    !features.includes(OrganizationFeature.ComplianceUSA);
  const hasNewClientDashboard = features.includes(OrganizationFeature.ClientDashboardNavigation);

  const getAnchorProps = () => {
    let props: Partial<AnchorProps> = {};

    if (isCHASOnlyCompliance) {
      props.href = hasNewClientDashboard
        ? `/organizations/${id}/client-dashboard`
        : `/organizations/${id}/supply-chains-v2`;
      return props;
    }

    if (features.includes(Client)) {
      props = {
        style: { cursor: 'pointer' },
        onClick: handleChangeOrganizationToClient(id)
      };
    } else if (features.includes(Subscriber)) {
      props.href = `/organizations/${id}`;
    } else {
      props.href = `/links/${id}`;
    }
    return props;
  };

  return (
    <AnchorListItem tooltip inset icon={getIconByLevel(rank)} {...getAnchorProps()} style={{ paddingLeft: rank * 16 }}>
      {name}
    </AnchorListItem>
  );
};
